import { render, staticRenderFns } from "./MarginHealingCard.vue?vue&type=template&id=0960937e&scoped=true&"
import script from "./MarginHealingCard.vue?vue&type=script&lang=js&"
export * from "./MarginHealingCard.vue?vue&type=script&lang=js&"
import style0 from "./MarginHealingCard.vue?vue&type=style&index=0&id=0960937e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960937e",
  null
  
)

export default component.exports